var Shopify = Shopify || {};
Shopify.money_format = window.shopMoneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

$(document).ready(function(){

  if($(".pro_variants").find(".swatch").length == 1){
    $('.color_items_wrapper .available').prependTo('.color_items_wrapper');
  }

  const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  /* Set scrollbar on color option variant */
  if($(".color_items_wrapper").length > 0){
    setScrollOnColorOption('');
  }
  
  // New address form hide in mobile
  if(window.innerWidth < 768){
    if($("#AddAddress").length > 0){
      $("#AddAddress").hide();
    }
  }

  // Toggle new address form on button click
  $(document).on("click", ".add_new_add", function(){
    if($(this).parents(".add_new_address_block").find("#AddAddress").is(":visible")){
      $(this).parents(".add_new_address_block").find("#AddAddress").hide();
    }else{
      $(this).parents(".add_new_address_block").find("#AddAddress").show();
    }
  });

  //Change color wise image on color swatch click (in product grid)
  $(document).on("click", ".color_swatch", function(){
    if(!$(this).hasClass("active")){
      $(this).parents(".pro-color-variant").find("li a.active").removeClass("active");
      $(this).addClass("active");
    }
    var image = $(this).parent("li").find(".var_img").find(".responsive-image-wrapper").html();
    var cltTitle = $(this).attr("title");
    $(this).parents(".pro-color-variant").find(".curr_color").text(cltTitle);
    if(image){
      $(this).parents(".grid-view-item").find(".grid-view-item-image .responsive-image-wrapper").eq(0).html(image);
    }
  });

  /* details tab */
  $(document).on("click", ".product_desc_txt .collapsible-tab", function(){
    var is_open = $(this).find(".collapsible-tab-content").attr("open");
    if(typeof is_open == 'undefined' || is_open == '') {
      $(this).parents(".product_desc_txt").find(".collapsible-tab-content").removeAttr("open");
      setTimeout(() => {
        $(this).find(".collapsible-tab-content").attr("open", "open");
      }, 500)
      
    } 
  });

  $(document).on("click", ".swatch-items-wrapper input[type='radio']", function(event){
    $(this).parents(".swatch").find(".variant_val").text($(this).val());
  });

  /* Prevent checkout button without accept terms & conditions */
  $(document).on("click", "button[name='checkout'], .additional-checkout-buttons", function(e){
    var is_checkbox = $(this).parent("div").find(".check-note").find(".term_condition_accept").prop("checked");
    if(is_checkbox == false){
      $(this).parent("div").find(".check-note").find("label span").addClass('unchecked_box');
      return false;
    }
  });

  $(document).on("change", "input[type='checkbox'][name='term_and_condition']", function(){
    if($(this).prop("checked") == true){
      if($(this).parents(".check-note").find("label span").hasClass("unchecked_box")){
        $(this).parents(".check-note").find("label span").removeClass("unchecked_box");
      }
      if($(this).parents(".ajaxcart__footer").find(".additional-checkout-buttons").hasClass("unchecked_term_condition_box")){
        $(this).parents(".ajaxcart__footer").find(".additional-checkout-buttons").removeClass("unchecked_term_condition_box");
      }
    }else{
      if(!$(this).parents(".ajaxcart__footer").find(".additional-checkout-buttons").hasClass("unchecked_term_condition_box")){
        $(this).parents(".ajaxcart__footer").find(".additional-checkout-buttons").addClass("unchecked_term_condition_box");
      }
    }
  })

  // About us page tab scroll  
  $(document).on("click", ".about-page-wrapper .tab-wrapper li", function(){
    $(this).parents(".tab-wrapper").find("li.active").removeClass("active");
    var id = $(this).find("a").data("href");
    if($(".tab-wrapper.sticky").length > 0){
      if($(window).width() < 768){
        if($(".mobile-nav-bar-wrapper").hasClass("hide-header")){
          var header = parseFloat($(".tab-wrapper.sticky").innerHeight()) + 30;
        }else{
          var header = parseFloat($(".mobile-nav-bar-wrapper").innerHeight()) + parseFloat($(".tab-wrapper.sticky").innerHeight()) + 30;
        }
      }else{
        if($(".site-header").hasClass("hide-header")){
          var header = parseFloat($(".tab-wrapper.sticky").innerHeight()) + 30;
        }else{
          var header = parseFloat($(".site-header").innerHeight()) + parseFloat($(".tab-wrapper.sticky").innerHeight()) + 30;
        }
      }
    }else{
      if($(window).width() < 768){
        var header = parseFloat($(".mobile-nav-bar-wrapper").innerHeight())+parseFloat($(".tab-wrapper").innerHeight() + 30);
      }else{
        var header = parseFloat($(".site-header").innerHeight())+parseFloat($(".tab-wrapper").innerHeight() + 30);
      }
    }
    
    var divHeight = $("#"+id).offset().top;
    var total = parseFloat(divHeight-header);
    $(this).addClass("active");
    var target = this.hash;
    $('html, body').stop().animate({
      scrollTop: total
    }, '800', 'swing', function () {
    });
  });

  // Show second image on image hower in cart drawer
  $(document).on("mouseenter", ".drawer_product .item_image", function(){
    $(this).find(".responsive-image-wrapper:first").hide();
    $(this).find(".hidden").show().css("opacity", "1");
  });

  $(document).on("mouseleave", ".drawer_product .item_image", function(){
    $(this).find(".responsive-image-wrapper").show();
    $(this).find(".hidden").hide().css("opacity", "0");
  });

  // Show second image on image touch in cart drawer (Mobile)
  /*$(document).on("touchstart", ".drawer_product .item_image", function(){
    $(this).find(".responsive-image-wrapper:first").hide();
    $(this).find(".hidden").show().css("opacity", "1");
  });

  $(document).on("touchend", ".drawer_product .item_image", function(){
    $(this).find(".responsive-image-wrapper").show();
    $(this).find(".hidden").hide().css("opacity", "0");
  });*/

  // Show second image on image hower in search page
  $(document).on("mouseenter", ".search-item-box .grid-view-item-image", function(){
    if($(this).find(".sec_img").length > 0){
      $(this).find(".responsive-image-wrapper:first").hide();
      $(this).find(".sec_img").removeClass("hidden");
    }
  });

  $(document).on("mouseleave", ".search-item-box .grid-view-item-image", function(){
    if($(this).find(".sec_img").length > 0){
      $(this).find(".responsive-image-wrapper").show();
      $(this).find(".sec_img").addClass("hidden");
    }
  });

  // Show second image on image touch in search page (Mobile)
  /*$(document).on("touchstart", ".search-item-box .grid-view-item-image", function(){
    if($(this).find(".sec_img").length > 0){
      $(this).find(".responsive-image-wrapper:first").hide();
      $(this).find(".sec_img").removeClass("hidden");
    }
  });

  $(document).on("touchend", ".search-item-box .grid-view-item-image", function(){
    if($(this).find(".sec_img").length > 0){
      $(this).find(".responsive-image-wrapper").show();
      $(this).find(".sec_img").addClass("hidden");
    }
  });*/

  // Show second image on image touch in product grid (Mobile)
  /*$(document).on("touchstart", ".grid-view-item-image .reveal", function(){
    //$(this).find(".responsive-image-wrapper:first").hide();
    //$(this).find(".hidden").show().css("opacity", "1");
  });
  
  $(document).on("touchend", ".grid-view-item-image .reveal", function(){
    //$(this).find(".responsive-image-wrapper").show();
    //$(this).find(".hidden").hide().css("opacity", "0");
  });*/


  /* Reverse scroll header menu */
  window.onload = () => {
  	sticky_header();
  };
  
  window.onscroll = () => {
  	sticky_header();
  };
  
  window.onresize = (event) => {
  	sticky_header();
  };

  let lastScroll = 0;
  function sticky_header(){
    let header_hegith = $(window).innerWidth() < 992 ? $('.mobile-nav-bar-wrapper').innerHeight() : $('.header_hide').innerHeight();
    let scroll = $(window).scrollTop();
    if (scroll > parseFloat(header_hegith)*2 && scroll > lastScroll) {
      $(window).innerWidth() < 992 ? $('.mobile-nav-bar-wrapper').addClass('hide-header') : $('.header_hide').addClass('hide-header');
      $('.sticky-header').addClass('hide-header');
      if($(".page_about").length > 0){
        $(".page_about").find(".tab-wrapper.sticky").css("top", "0");
      }
    } else if (scroll < lastScroll) {
      $(window).innerWidth() < 992 ? $('.mobile-nav-bar-wrapper').removeClass('hide-header') : $('.header_hide').removeClass('hide-header');
      $('.sticky-header').removeClass('hide-header');
      if($(".page_about").length > 0){
        $(window).innerWidth() < 992 ? $(".page_about").find(".tab-wrapper.sticky").css("top", "71px") : $(".page_about").find(".tab-wrapper.sticky").css("top", "113px");
        
      }
    }
    lastScroll = scroll;
  }

  /* Show custom selected file name on product page */
  $(document).on("change", "#custom_file", function(e){
    if(e.target.files.length > 0){
      var fileName = e.target.files[0].name;
      $(this).parent(".custom_file").find("p.default_text").addClass("hide");
      $(this).parent(".custom_file").find("p.file_name").text(fileName).removeClass("hide");
    }else{
      $(this).parent(".custom_file").find("p.default_text").removeClass("hide");
      $(this).parent(".custom_file").find("p.file_name").text('').addClass("hide");
    }
  });

  // Open close filter sidebar in desktop
  $(document).on("click", ".facet_filter_heading", function(){
    if(window.innerWidth > 1024){
      if($(this).hasClass("active")){
        $(this).removeClass("active");
        $(this).parents("#CollectionFiltersForm").find(".facets__form-inner .facets__wrapper.open").removeClass("open");
        $(this).parents(".collection_grid").find("#CollectionProductGrid.open").removeClass("open");
        $(this).parents(".collection_grid").removeClass("open_filter");
      }else{
        $(this).addClass("active");
        $(this).parents("#CollectionFiltersForm").find(".facets__form-inner .facets__wrapper").addClass("open");
        $(this).parents(".collection_grid").find("#CollectionProductGrid").addClass("open");
        $(this).parents(".collection_grid").addClass("open_filter");
      }
    }
  });

  /* Grid & List view in color option on product page  */
  $(document).on("click", ".pro-swatch-btns .pro-swatch-viewbtn", function(){
    $(this).parent("div").find(".active").removeClass("active");
    $(this).addClass("active");
    if($(this).data("layout") == 'list'){
      $(this).parents(".swatch").find(".swatch-items-wrapper").addClass("layout_list");
      $(this).parents(".swatch").find(".hs__arrows").addClass("hide");
    }else{
      $(this).parents(".swatch").find(".swatch-items-wrapper").hasClass("layout_list") ? $(this).parents(".swatch").find(".swatch-items-wrapper").removeClass("layout_list") : '';
      
      if($(this).parents(".pro_variants").find(".swatch").length > 1){
        setScrollOnColorOption('multi-option');
      }else{
        setScrollOnColorOption('');
      }
    }
  });

  $(document).on("click", ".layout_list .swatch-element span", function(){
    $(this).parents(".swatch-element").find("input[type='radio']").trigger("click");
  });

  /* Welcome popup newsletter form */
  $(document).on("click", "#subscribe", function(event) {
    event.preventDefault();
    
    var form = $(this).parents("form");
    var email = form.find(".email").val();
    const errorMsg = form.find(".errors ul li");
    form.find(".errors.hide").removeClass("hide");

    if(!email){
      errorMsg.text("Please enter your email address");
      form.find(".email").focus();
      return false;
    }else if(!emailRegex.test(email)){
      errorMsg.text("Please enter your valid email address");
      form.find(".email").focus();
      return false;
    }else{
      var data = form.serialize();
      var url = form.attr("action");

      $.ajax({
        type:'POST',
        url:url,
        data:data,
        cache: false,
        success: function(cartdata){
          if($(cartdata).find("#newsletter-popup_form").find(".form-success").length > 0 || 
            $(cartdata).find("#newsletter-popup-mobile_form").find(".form-success").length > 0 || 
            $(cartdata).find("#newsletter-popup_form").find(".errors").not(".hide").length > 0 || 
            $(cartdata).find("#newsletter-popup-mobile_form").find(".errors").not(".hide").length > 0){
            
            if($(window).width() > 768){
              $("#fullscreen").find(".popup--body").find(".popup--description").hide();
              $("#fullscreen").find("#newsletter-popup_form").html($(cartdata).find("#fullscreen").find("#newsletter-popup_form").html())
            }else{
              $("#slide-up").find(".popup--body").find(".popup--description").hide();
              $("#slide-up").find("#newsletter-popup-mobile_form").html($(cartdata).find("#slide-up").find("#newsletter-popup-mobile_form").html())
            }
            
          }else{
            errorMsg.text("Email already exist!");
          }
        },
        error: function(xhr, status, error) {
          var err = xhr.responseText;
          if(err.Message){
            errorMsg.text(err.Message);
          }
        }
      });
      return false;
    }
  });
  
  
  // Registration form validation
  if($(".register_btn").length > 0){
    $(document).on("click", ".register_btn", function(event){
      $form = $(this).parents("form");
      const fname = $form.find(".fname").val();
      const lname = $form.find(".lname").val();
      const email = $form.find(".email").val();
      const password = $form.find(".password").val();
      const errorMsg = $form.find(".errors ul li");
      $form.find(".errors.hide").removeClass("hide");

      if(!fname){
        errorMsg.text("Please enter your name");
        $form.find(".fname").focus();
        return false;
      }else if(!lname){
        errorMsg.text("Please enter your last name");
        $form.find(".lname").focus();
        return false;
      }else if(!email){
        errorMsg.text("Please enter your email address");
        $form.find(".email").focus();
        return false;
      }else if(!emailRegex.test(email)){
        errorMsg.text("Please enter your valid email address");
        $form.find(".email").focus();
        return false;
      }else if(!password){
        errorMsg.text("Please enter your password");
        $form.find(".password").focus();
        return false;
      }else if(password.length < 5){
        errorMsg.text("Password is too short (minimum is 5 characters)");
        $form.find(".password").focus();
        return false;
      }else{
        return true;
      }
    });
  }

  // Login form validation
  if($(".login_btn").length > 0){
    $(document).on("click", ".login_btn", function(event){
      $form = $(this).parents("form");
      const email = $form.find(".email").val();
      const password = $form.find(".password").val();
      const errorMsg = $form.find(".errors ul li");
      $form.find(".errors.hide").removeClass("hide");

      if(!email){
        errorMsg.text("Please enter your email address");
        $form.find(".email").focus();
        return false;
      }else if(!emailRegex.test(email)){
        errorMsg.text("Please enter your valid email address");
        $form.find(".email").focus();
        return false;
      }else if(!password){
        errorMsg.text("Please enter your password");
        $form.find(".password").focus();
        return false;
      }else{
        return true;
      }
    });
  }

  // Footer newsletter form validation
  if($("#subscribe_news").length > 0){
    $(document).on("click", "#subscribe_news", function(event){
      $form = $(this).parents("form");
      const email = $form.find(".footer-email-input").val();
      const errorMsg = $form.find(".errors ul li");
      $form.find(".errors.hide").removeClass("hide");

      if(!email){
        errorMsg.text("Please enter your email address");
        $form.find(".footer-email-input").focus();
        return false;
      }else if(!emailRegex.test(email)){
        errorMsg.text("Please enter your valid email address");
        $form.find(".footer-email-input").focus();
        return false;
      }else{
        return true;
      }
    });
  }

  // Forgot password form validation
  if($(".reset_pass_btn").length > 0){
    $(document).on("click", ".reset_pass_btn", function(event){
      $form = $(this).parents("form");
      const email = $form.find(".email").val();
      const errorMsg = $form.find(".errors ul li");
      $form.find(".errors.hide").removeClass("hide");

      if(!email){
        errorMsg.text("Please enter your email address");
        $form.find(".email").focus();
        return false;
      }else if(!emailRegex.test(email)){
        errorMsg.text("Please enter your valid email address");
        $form.find(".email").focus();
        return false;
      }else{
        return true;
      }
    });
  }

  // Activate account form validation
  if($(".activate_acc").length > 0){
    $(document).on("click", ".activate_acc", function(event){
      $form = $(this).parents("form");
      const password = $form.find("#CustomerPassword").val();
      const confPassword = $form.find("#CustomerPasswordConfirmation").val();
      const errorMsg = $form.find(".errors ul li");
      $form.find(".errors.hide").removeClass("hide");

      if(!password){
        errorMsg.text("Please enter your new password");
        $form.find("#CustomerPassword").focus();
        return false;
      }else if(!confPassword){
        errorMsg.text("Please enter your confirm password");
        $form.find("#CustomerPasswordConfirmation").focus();
        return false;
      }else if(password != confPassword){
        errorMsg.text("Your password and confirm password do not match");
        $form.find("#CustomerPasswordConfirmation").val('');
        $form.find("#CustomerPasswordConfirmation").focus();
        return false;
      }else{
        return true;
      }
    });
  }

  // Reset password form validation
  if($(".reset_password_btn").length > 0){
    $(document).on("click", ".reset_password_btn", function(event){
      $form = $(this).parents("form");
      const password = $form.find("#ResetPassword").val();
      const confPassword = $form.find("#PasswordConfirmation").val();
      const errorMsg = $form.find(".errors ul li");
      $form.find(".errors.hide").removeClass("hide");

      if(!password){
        errorMsg.text("Please enter your new password");
        $form.find("#ResetPassword").focus();
        return false;
      }else if(!confPassword){
        errorMsg.text("Please enter your confirm password");
        $form.find("#PasswordConfirmation").focus();
        return false;
      }else if(password != confPassword){
        errorMsg.text("Your password and confir password do not match");
        $form.find("#PasswordConfirmation").val('');
        $form.find("#PasswordConfirmation").focus();
        return false;
      }else{
        return true;
      }
    });
  }

  /* Address page validation */
  if($(".btn_address").length > 0){
    $(document).on("click", ".btn_address", function(event){
      $form = $(this).parents("form");
      const fname = $form.find(".fname");
      const lname = $form.find(".lname");
      const company = $form.find(".company");
      const add1 = $form.find(".add1");
      const city = $form.find(".city");
      const country = $form.find(".country");
      const zipcode = $form.find(".zipcode");
      const phone_no = $form.find(".phone_no");
      $form.find(".form_error").text("");

      if(!fname.val()){
        $form.find('.err-fname').text('Enter your first name');
        fname.focus();
        return false;
      }else if(!lname.val()){
        $form.find('.err-lname').text('Enter your last name');
        lname.focus();
        return false;
      }else if(!company.val()){
        $form.find('.err-company').text('Enter your company name');
        company.focus();
        return false;
      }else if(!add1.val()){
        $form.find('.err-add1').text('Enter your address');
        add1.focus();
        return false;
      }else if(!city.val()){
        $form.find('.err-city').text('Enter your city name');
        city.focus();
        return false;
      }else if(country.val() == '---'){
        $form.find('.err-country').text('Select your country');
        country.focus();
        return false;
      }else if(!zipcode.val()){
        $form.find('.err-zipcode').text('Enter your zipcode');
        zipcode.focus();
        return false;
      }else if(!phone_no.val()){
        $form.find('.err-phone_no').text('Enter your phone number');
        phone_no.focus();
        return false;
      }else{
        return true;
      }
    });
  }

  // Article page comment form validation
  if($(".comment_btn").length > 0){
    $(document).on("click", ".comment_btn", function(event){
      $form = $(this).parents("form");
      const name = $form.find("#CommentAuthor").val();
      const email = $form.find("#CommentEmail").val();
      const msg = $form.find("#CommentBody").val();
      const errorMsg = $form.find(".errors ul li");
      $form.find(".errors.hide").removeClass("hide");

      if(!name){
        errorMsg.text("Please enter your name");
        $form.find("#CommentAuthor").focus();
        return false;
      }else if(!email){
        errorMsg.text("Please enter your email address");
        $form.find("#CommentEmail").focus();
        return false;
      }else if(!emailRegex.test(email)){
        errorMsg.text("Please enter your valid email address");
        $form.find("#CommentEmail").focus();
        return false;
      }else if(!msg){
        errorMsg.text("Please enter your message");
        $form.find("#CommentBody").focus();
        return false;
      }else{
        return true;
      }
    });
  }

  // Contact page form validation
  if($(".contact_btn").length > 0){
    $(document).on("click", ".contact_btn", function(event){
      $form = $(this).parents("form");
      const name = $form.find("#form_name").val();
      const email = $form.find("#form_email").val();
      const msg = $form.find("#form_message").val();
      const errorMsg = $form.find(".errors ul li");
      $form.find(".errors.hide").removeClass("hide");

      if(!name){
        errorMsg.text("Please enter your name");
        $form.find("#form_name").focus();
        return false;
      }else if(!email){
        errorMsg.text("Please enter your email address");
        $form.find("#form_email").focus();
        return false;
      }else if(!emailRegex.test(email)){
        errorMsg.text("Please enter your valid email address");
        $form.find("#form_email").focus();
        return false;
      }else if(!msg){
        errorMsg.text("Please enter your message");
        $form.find("#form_message").focus();
        return false;
      }else{
        return true;
      }
    });
  }
  
});

function triggerFirstAvailableVariantOption(html){
  setTimeout(() => {
    $(html).find('.swatch-items-wrapper:eq(0)').find(".options-0:checked").prop("checked", false);
    $(html).find('.swatch-items-wrapper:eq(0) .available:eq(0)').find("input[type='radio']").trigger("click");
  }, 500);
}

if($(".page_about").find(".tab-wrapper").length > 0){
  var div_top = $('.tab-wrapper').offset().top;
  
  if($(window).width() < 768){
    var div_header = $('.mobile-nav-bar-wrapper').innerHeight();
  }else{
    var div_header = $('.site-header').height();
  }
  
  var div_total = parseFloat(div_top-div_header);
  var div_tab = $('.tab-wrapper').innerHeight();
  var div_footer = $(".footer-main").offset().top;

  $(window).scroll(function() {
    var window_top = $(window).scrollTop() - 0;
    if (window_top > div_total) {
      if (!$('.tab-wrapper').is('.sticky')) {
        $('.tab-wrapper').addClass('sticky');
      }
    } else {
      $('.tab-wrapper').removeClass('sticky');
    }

    if(div_footer < window_top+parseFloat(div_tab)+div_header){
      $('.tab-wrapper').removeClass('sticky');
    }

    $('.tab_content .content_wrap').each(function () {
      var id = $(this).attr("id");
      var ttl = div_header;
      var offset = parseFloat($(this).offset().top - ttl);
      if(window_top >= offset){
        $('.tab-wrapper').find("a[data-href='#"+id+"']").parent("li").addClass("active");
      }
    });
  });
}

function setScrollOnColorOption(option){
  var instance = $(".pro_variants");
  $.each( instance, function(key, value) {
    
    $(instance[key]).find(".swatch").each(function(){
      var wd = 0;
      if(option == 'multi-option'){
        $(this).find(".swatch-items-wrapper .swatch-element.available").each(function(index){
          index > 0 ? wd+= $(this).innerWidth()+14 : wd+= $(this).innerWidth();
        });
      }else{
        $(this).find(".swatch-items-wrapper .swatch-element").each(function(index){
          index > 0 ? wd+= $(this).innerWidth()+14 : wd+= $(this).innerWidth();
        });
      }
      
      //console.log(wd, $(this).find(".swatch-items-wrapper").innerWidth())
      if(wd > $(this).find(".swatch-items-wrapper").innerWidth()){
        $(this).find(".hs__arrows").removeClass("hide");
      }else{
        $(this).find(".hs__arrows").addClass("hide");
      }

      let isDown = false;
      let startX;
      let scrollLeft;
      var arrows = $(this).find(".arrow"),
          prevArrow = arrows.filter('.arrow-prev'),
          nextArrow = arrows.filter('.arrow-next'),
          box = $(this).find(".swatch-items-wrapper"), 
          x = 0,
          mx = 0,
          maxScrollWidth = box[0].scrollWidth - (box[0].clientWidth / 2) - (box.width() / 2);

      $(arrows).on('click', function() {
        if ($(this).hasClass("arrow-next")) {
          x = ((box.width() / 2)) + box.scrollLeft() - 10;
          box.animate({
            scrollLeft: x,
          })
        } else {
          x = ((box.width() / 2)) - box.scrollLeft() -10;
          box.animate({
            scrollLeft: -x,
          })
        } 
      });

      $(box).on({
        mousedown: function(e) {
          isDown = true;
          startX = e.pageX - this.offsetLeft;
          scrollLeft = this.scrollLeft;
        },
        mouseup: function(e) {
          isDown = false;
        },
        mouseleave: function(e) {
          isDown = false;
        },
        mousemove: function(e) {
          if(!isDown) return;
          e.preventDefault();
          const x = e.pageX - this.offsetLeft;
          const walk = (x - startX) * 0.5; //scroll-fast
          this.scrollLeft = scrollLeft - walk;
        },
        scroll: function() {
          toggleArrows();
        }
      });

      $(document).on("mouseup", function(){
        mx = 0;
      });
      $(document).on("mouseleave", function(){
        mx = 0;
      });
      
      function toggleArrows() {
        if(box.scrollLeft() > maxScrollWidth - 10) {
          nextArrow.addClass('disabled');
          prevArrow.removeClass('disabled');
        } else if(box.scrollLeft() < 10) {
          prevArrow.addClass('disabled');
          nextArrow.removeClass('disabled');
        } else{
          nextArrow.removeClass('disabled');
          prevArrow.removeClass('disabled');
        }
      }
    });
  });
}

function setAvailableVarFirst(r){
  $(r).find('.color_items_wrapper .available').prependTo('.color_items_wrapper');
}

/* Hide soldout variant */
class showAvailableColor extends HTMLElement {
  constructor(){
    super();
    this.addEventListener("change", this.updateVariantsData.bind(this));
  }

  updateVariantsData(event, this_obj){
    event.stopPropagation();
    var newURL = this.checkRedirect(event);
    if(newURL){
      location.href = newURL;
      return;
    }
    this.getSelectedVar();
    this.getvariant();
    this.updateVariants(event, this_obj)
  }

  updateVariants(event, this_obj){
    if(this.variant && this.variant.featured_image.src){
      var currImage = this.variant.featured_image.src;
      var currZoomImage = this.variant.featured_image.src;
      if(currImage && currZoomImage){
        $(this).parents(".product-single-wrapper").find(".product-medias__main").find(".swiper-wrapper").find(".swiper-slide").eq(0).find("img:first").attr("src","".concat(currImage, "&width=1024"));
        $(this).parents(".product-single-wrapper").find(".product-medias__main").find(".swiper-wrapper").find(".swiper-slide").eq(0).find("img:first").attr("data-image-zoom", currZoomImage);
        $(this).parents(".product-single-wrapper").find(".product-medias__main").find(".swiper-wrapper").find(".swiper-slide").eq(0).find("img[role='presentation']").remove();
      }
    }
    
    var obj = $(this);
    if(event.target.classList.contains("options-0")){
      var variantvalue = event.target.value;
      var currSKU = event.target.dataset.sku;
      var secondBoxFirstOption = $(this).find("input[type='radio'].options-1:checked").val();
      var secondBoxFirstOptionIndex;
      var thirdBoxFirstOptionIndex;
      var thirdBoxFirstOption = $(this).find("input[type='radio'].options-2:checked").val();
      $(this).find("input[type='radio'].options-1").each(function(index){
        if($(this).is(":checked")){
          secondBoxFirstOptionIndex = index;
        }
      });

      if(secondBoxFirstOption == undefined){
        secondBoxFirstOptionIndex = 0;
        secondBoxFirstOption = $(this).find("input[type='radio'].options-1").eq(0).val();
      }

      $(this).find("input[type='radio'].options-2").each(function(index){
        if($(this).is(":checked")){
          thirdBoxFirstOptionIndex = index;
        }
      });
      
      if(thirdBoxFirstOption == undefined){
        thirdBoxFirstOptionIndex = 0;
        thirdBoxFirstOption = $(this).find("input[type='radio'].options-2").eq(0).val();
      }
     
      $(this).find(".options-1").each(function(index){
        var secondBoxFirstOption = $(this).val();
        obj.find("input[type='radio'].options-1").eq(index).parents(".swatch-element").removeClass('soldout available hidden').addClass("hidden");
        getSelectProdcutClass(obj, variantvalue, secondBoxFirstOption, thirdBoxFirstOption, function(className){
          if(className){
            obj.find("input[type='radio'].options-1").eq(index).parents(".swatch-element").removeClass('soldout available hidden').addClass(className).show();
          }
        });
      });
      
      setTimeout(() => {
        $(this).find('.swatch-items-wrapper:eq(1) .available:first').find("input[type='radio']").trigger("click");
      }, 500);

      $(event.target).parents(".pro_variants").find(".swatch").each(function(){
        if($(this).find(".layout_list").length == 0){
          var wd = 0;
          $(this).find(".swatch-items-wrapper .swatch-element").each(function(index){
            index > 0 ? wd+= $(this).innerWidth()+14 : wd+= $(this).innerWidth();
          });
          //console.log('drawer', wd, $(this).find(".swatch-items-wrapper").innerWidth())
          if(wd > $(this).find(".swatch-items-wrapper").innerWidth()){
            $(this).find(".hs__arrows").removeClass("hide");
            if($(this).find(".hs__arrows .arrow-prev").hasClass("disabled") && 
                $(this).find(".hs__arrows .arrow-next").hasClass("disabled")){
              $(this).find(".hs__arrows .arrow-next").removeClass("disabled");
            }
          }else{
            $(this).find(".hs__arrows").addClass("hide");
          }
        }
      });
      if($(this).find(".pro_variants").find(".swatch").length > 1){
        setTimeout(() => {
          $(this).find('.color_items_wrapper .available').prependTo('.color_items_wrapper');
        }, 300)
      }
    }

    /*if(event.target.closest(".swatch .swatch-items-wrapper").classList.contains("color_items_wrapper")){
      var currImage = event.target.dataset.img;
      var currZoomImage = event.target.dataset.zoomimg;
      if(currImage && currZoomImage){
        $(".product-medias__main").find(".swiper-wrapper").find(".swiper-slide").eq(0).find("img:first").attr("src", currImage);
        $(".product-medias__main").find(".swiper-wrapper").find(".swiper-slide").eq(0).find("img:first").attr("data-image-zoom", currZoomImage);
        $(".product-medias__main").find(".swiper-wrapper").find(".swiper-slide").eq(0).find("img[role='presentation']").remove();
      }
    }*/
  }

  getSelectedVar() {
    this.option_arr = [];
    const option_arr = Array.from(this.querySelectorAll(".swatch-items-wrapper"));
    option_arr.map((input)=> {
      const select = input.querySelector("input[type='radio']:checked");
      this.option_arr.push(select.value);
    });
    this.options = this.option_arr;
  }
  
  getvariant() {
    this.variant = this.getVariantList().find((variant)=> {
      if(this.options.join(" / ") === variant.title){ 
        return variant;
      }
    });
  }

  getVariantList() {
    this.variant_list = JSON.parse(this.querySelector(".product_var_json").textContent);
    return this.variant_list;
  }

  checkRedirect(event){
    if(!event.target.closest(".swatch .swatch-items-wrapper").classList.contains("color_items_wrapper")){
      if(event.target.closest(".swatch-element").dataset.url){
        var newURL = location.href.split("/products")[0].concat(event.target.closest(".swatch-element").dataset.url);
        return newURL;
      }
    }
    //return;
  }
}

customElements.define('var-list', showAvailableColor);

/* Find disable variant and return "disable" or "active" class */
function getSelectProdcutClass(obj, optOne, optTwo, optThree, callback){
  $('select[name="id"] option').each(function(){
    var selectedText = $(this).data("val");
    selectedText = selectedText.split(' / ');
    
    if(typeof optThree == 'undefined' || optThree == ''){
      if(optOne == selectedText[0] && optTwo == selectedText[1]){
        callback($(this).attr('class'));
        return false;
      }
    }else{
      if(optOne.replace(/\s/g, '') == selectedText[0] && optTwo == selectedText[1] && optThree == selectedText[2]){
        callback($(this).attr('class'));
        return false;
      }
    }
  });
}

// Change vriant in cart drawer product
class VariantChangeCls extends HTMLElement {
  constructor(){
    super();
    this.addEventListener("change", this.update.bind(this));
  }

  update(event){
    this.getSelectedVar();
    this.getvariant();
    this.buttonChange();
    this.setCurrentId();
    this.getVariantImage(event);
    this.setPrice();
  }

  getSelectedVar() {
    this.option_arr = [];
    const option_arr = Array.from(this.querySelectorAll("ul"));
    option_arr.map((input)=> {
      const select = input.querySelector(".product_option:checked");
      this.option_arr.push(select.value);
    });
    this.options = this.option_arr;
  }
  
  getvariant() {
    this.variant = this.getVariantList().find((variant)=> {
      if(this.options.join(" / ") === variant.title){ 
        return variant;
      }
    });
  }

  buttonChange() {
    const btn = this.querySelector("[type='button']");
    if(!btn) return;
    if(!this.variant){ 
      btn.textContent = "Unavailable";
      btn.disabled = true;
    }else{ 
      if(this.variant.available){
        btn.textContent = "Add to cart";
        btn.disabled = false;
      }else{
        btn.textContent = "Sold out";
        btn.disabled = true;
      }
    } 
  }

  setCurrentId() {
    if(!this.variant) return;
    const form = this.querySelector("form");
    form.querySelector("input[name='id']").value = this.variant.id;
    form.querySelector("input[name='product-id']").value = this.variant.id;
  }

  getVariantImage(event) {
    if(event.target.closest("li").querySelector(".var_img")){
      const newImg = event.target.closest("li").querySelector(".var_img").innerHTML;
      event.target.closest(".product-item--wrap").querySelector(".item_image a").querySelectorAll(".responsive-image-wrapper")[0].innerHTML = newImg;
    }
  }

  setPrice(){
    if(!this.variant) return;
    /*if(this.variant.compare_at_price){
     this.querySelector(".product-grid--price .com_money").innerHTML = theme.Currency.formatMoney(this.variant.compare_at_price, theme.moneyFormat)
    }*/
    this.querySelector(".product-grid--price .money").innerHTML = Shopify.formatMoney(parseFloat(this.variant.price)), Shopify.money_format
  }

  getVariantList() {
    this.variant_list = JSON.parse(this.querySelector(".product_var_json").textContent);
    return this.variant_list;
  }
}

customElements.define('product-grid-item', VariantChangeCls);

/* cart page update */
class Cart extends HTMLElement {
  constructor(){
    super();
  }
  
  updateQuantity(line, quantity){
    var request = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
      body: JSON.stringify({
        line,
        quantity
      })
    };

    fetch("/cart/change.js", request)
    .then( response => {
      if (!response.ok) { throw response }
      return response.json()
    })
    .then( response_data => {
      update_cart_drawer("/cart");
    })
    .catch( err => {
      err.text().then( errorMessage => {
        update_cart_drawer("/cart", JSON.parse(errorMessage)['message'], line);
      });
    });
  }   
} 
customElements.define('cart-item', Cart);


/* Cart item remove */
class CartItemRemove extends HTMLElement{
  constructor() {
    super();
    this.querySelectorAll(".cart__remove").forEach(btn => {
      btn.addEventListener("click", function(event){
        event.preventDefault();
        this.closest("cart-item").updateQuantity(this.dataset.index, 0);
      })
    });
  }
}
customElements.define('cart-remove', CartItemRemove);

/* Cart quantity update */
class ChangeQuantity extends Cart {
  constructor(){
    super();
    this.input = this.querySelector("input");
    this.querySelectorAll(".js-qty__adjust").forEach((button) => button.addEventListener("click", this.ChangeVal.bind(this, button)));
    this.querySelectorAll(".js-qty__num").forEach((input) => input.addEventListener("change", this.ChangeVal.bind(this, input)));
  }

  ChangeVal(obj, event){
    if(event.type == 'click'){
      obj.classList.contains('js-qty__adjust--minus') ? this.input.value = Math.max(0, parseInt(this.input.value, 10) - 1)
        : this.input.value = parseInt(this.input.value, 10) + 1
    }
    
    var index = obj.dataset.index;
    var input_val = parseInt(this.input.value);
    this.updateQuantity(index, input_val);
  }
}
customElements.define('item-qty', ChangeQuantity);

/* Update function for cart and cart drawer */
function update_cart_drawer(url, message='', index=''){
 fetch(url)
 .then(data => {return data.text()})
 .then(res => {
   var parse_data = new DOMParser().parseFromString(res, 'text/html');
   var count = 0;
   if(parse_data.querySelector(".cart_page")){
     document.querySelector('.cart_page').innerHTML = parse_data.querySelector(".cart_page").innerHTML;
   }

   if(message != '' && index != ''){
     document.querySelector(".js-qty__num[data-index='"+index+"']").closest("tr").querySelector(".cart_error").innerHTML = message;
     setTimeout(() => {
       document.querySelector(".js-qty__num[data-index='"+index+"']").closest("tr").querySelector(".cart_error").innerHTML = '';
     }, 4000);
   }
 });
}